module.exports = __webpack_public_path__ + "static/img/AmwayIcons.dff48a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/AmwayIcons.svg?5v2gxx
// module id = zzGp
// module chunks = 0